import { render, staticRenderFns } from "./NotAllowedView.vue?vue&type=template&id=af5958d0&scoped=true&lang=pug&"
import script from "./NotAllowedView.vue?vue&type=script&lang=ts&"
export * from "./NotAllowedView.vue?vue&type=script&lang=ts&"
import style0 from "./NotAllowedView.vue?vue&type=style&index=0&id=af5958d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af5958d0",
  null
  
)

export default component.exports